import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-mobile-terms-condition',
  templateUrl: './mobile-terms-condition.component.html',
  styleUrls: ['./mobile-terms-condition.component.css']
})
export class MobileTermsConditionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
